import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
// tslint:disable:max-line-length
import React from 'react';
export var EditorBlockquote = function EditorBlockquote(props) {
  var _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Create blockquote' : _props$ariaLabel,
      remProps = _objectWithoutProperties(props, ["ariaLabel"]);

  return React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    "aria-label": ariaLabel
  }, remProps), React.createElement("path", {
    d: "M0,1v7h4c0,2.2-1.8,4-4,4v3c3.8,0,7-3.2,7-7V1H0z M9,1v7h4c0,2.2-1.8,4-4,4v3c3.8,0,7-3.2,7-7V1H9z"
  }));
};